import React from "react";
import { pathArray, capitalizeFletter } from "../../utils/utils";
import { ReactComponent as Activate } from "../../images/Activate.svg";
import { ReactComponent as Deactivate } from "../../images/deactivate.svg";
import PropTypes from 'prop-types'
import { useLocation } from "react-router-dom";

import "./framelist.scss";

export default function Framelist({style}) {
  let pathname = useLocation().pathname;
  pathname = pathname.substring(1) === "" ? "/details" : pathname;

  const frames = pathArray.map((path, index) => {
    return (
      <div
        className="d-flex justify-content-start align-items-center"
        key={index}
      >
        {pathArray.indexOf(pathname.substring(1)) < index ? (
          <Deactivate />
        ) : (
          <Activate />
        )}
        <p className="text-secondary ms-3 mb-0">{capitalizeFletter(path)}</p>
      </div>
    );
  });

  return (
    <div style={style?style:{}} className="frame-container d-flex flex-column justify-content-between position-relative">
      <div className="line-dash position-absolute"></div>
      {frames}
    </div>
  );
}



Framelist.propTypes = {
  style:PropTypes.object
  }

